import { useState } from "react";
import DatePicker from "react-date-picker";

const DatePickerComponent = ({ label, name, input, meta, min_date,disabled }) => {
  const [value, setValue] = useState(input.value);
  const isError = meta && meta.touched && meta.invalid;

  return (
    <div className="form-group">
      {label && (
        <label htmlFor={name} className="label-form">
          {label}
        </label>
      )}
      <div className="calendar-group">
        <DatePicker
          minDate={min_date}
          calendarIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <rect
                fill="#595d6e"
                width="15.833"
                height="3.333"
                rx="1"
                transform="translate(1.667 4.167)"
              />
              <rect
                fill="#595d6e"
                opacity="0.3"
                width="15.833"
                height="8.333"
                rx="1"
                transform="translate(1.667 9.167)"
              />
            </svg>
          }
          onChange={(val) => {
            setValue(val);
            input?.onChange(val);
          }}
          disabled={disabled}
          value={value}
          locale="pl-PL"
          format="y-MM-dd"
        />
      </div>
      {isError && meta.error && <p className="inp-error">{meta.error}</p>}
    </div>
  );
};

export default DatePickerComponent;
